import {z} from "zod";

export const ClientSchema = z.object({
    uuid: z.string().optional(),
    name: z.string().min(1, "Name is required"),
    email: z.string().email("Invalid email").optional().or(z.literal('')),
    phone_number: z.string().regex(/^[0-9()-]{10}$/, "Phone number must be 10 digits and can only contain numbers, parentheses, and dashes").optional().or(z.literal('')),

    street_address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().regex(/^[A-Z]{2}$/, "State must be 2 letters").optional().or(z.literal('')),
    postal_code: z.string().regex(/^\d{5}$/, "Postal code must be 5 digits").optional().or(z.literal('')),
})